export type Star = Readonly<{ x: number; y: number; alpha: number }>;

/** Deterministic pseudo random generator (mulberry32) so star layouts are reproducible in tests. */
export const seededRandom = (seed: number): (() => number) => {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

export const generateStars = (count: number, width: number, height: number, seed: number): readonly Star[] => {
  const random = seededRandom(seed);
  return Array.from({ length: count }, () => ({
    x: Math.round(random() * width),
    y: Math.round(random() * height),
    alpha: Number((0.3 + random() * 0.7).toFixed(2)),
  }));
};

/** Encodes stars as a CSS box-shadow list so one 1px element paints the whole layer. */
export const starsToBoxShadow = (stars: readonly Star[]): string =>
  stars.map((star) => `${star.x}px ${star.y}px rgba(255,255,255,${star.alpha})`).join(',');
